export class ResourceData {
  public filename: string;
  public mimeType: string;
  public data: ArrayBuffer;
  public httpStatus: number;
}
